module.exports = __webpack_public_path__ + "img/orbit-simplicity-square.43e7e5f6.jpg";